<template>
  <div>
    <choice-test
      v-for="assessment in data.assessments"
      :key="assessment.url"
      :assessment="assessment"
      @start="start(assessment.code.id, assessment.url)"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ChoiceTest from './components/choice-test';
  import { openNewWindow } from '@/_helpers/utils';

  export default {
    name: 'TalentqChoiceTest',

    components: {
      ChoiceTest
    },

    computed: {
      ...mapGetters('interview_talentq', ['data', 'token'])
    },

    created() {
      if (this.data.is_finished) {
        this.$router.push({ name: 'interview', params: { token: this.token } });
      }
    },

    methods: {
      start(id, url) {
        console.log(`TQ assessment id: ${id}`);
        if (id === 4096) {
          const windowParams = {
            url: url,
            title: 'TalentQ special',
            width: 850,
            height: 700
          };
          openNewWindow(windowParams);
        } else {
          this.$router.push({ name: 'interview-talentq-test', params: { token: this.token, id } });
        }
      }
    }
  };
</script>
